<template>
    <div class="department row">
        <Sidebar :deptInfo="deptInfo" :mainBudget="mainBudget" :years="columns.expenditures" />
        <div class="content col-sm-9">
            <h1>{{ name }}</h1>
            <Nav :departments="departments" :mainBudget="mainBudget" />
            <Expenditures 
                :budget="deptExpenditures" 
                :department="department" 
                :years="columns.expenditures" 
                :ftes="deptFTEs"
            />
            <Changes 
                :changes="deptChanges" 
                :year="mainBudget.when" 
                :department="department" 
                :years="columns.changes" 
            />
            <Resources 
                :resources="deptResources" 
                :years="columns.resources" 
            />
        </div>
    </div>
</template>

<script>
    import Nav from '@/components/Nav';
    import Sidebar from '@/components/Sidebar';
    import Expenditures from '@/components/Expenditures';
    import Changes from '@/components/Changes';
    import Resources from '@/components/Resources';

    export default {
        name: 'Department',
        props: {
            'mainBudget' : Object,
            'department' : String, 
            'departments' : Array, 
            'expenditures' : Array, 
            'ftes' : Array, 
            'changes' : Array, 
            'resources' : Array,
            'columns' : Object
        },
        computed: {
            deptCode(){
                return this.department.toUpperCase()  
            },
            deptInfo() {
                return this.departments.filter((item)=>{
                    return item.dept_code == this.deptCode
                })[0]
            },
            deptExpenditures() {
                return this.expenditures.filter((item)=>{
                    return item.deptcode == this.deptCode  
                })
            },
            deptFTEs() {
                return this.ftes.filter((item)=>{
                    return item.deptcode == this.deptCode 
                })
            },
            deptChanges() {
                return this.changes.filter((item)=>{
                    return item.dept_code == this.deptCode
                })
            },
            deptResources() {
                return this.resources.filter((item)=>{
                    return item.dept == this.deptCode
                })
            },
            name() {
                return (this.deptInfo) ? this.deptInfo.department_or_fund_name : '';
            }
        },
        components: {
            Nav,
            Sidebar,
            Expenditures,
            Changes,
            Resources
        }
    }
</script>

<style lang="scss">

</style>
